exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".usc-bob {\r\n    padding-right: 15px;\r\n    padding-left: 15px;\r\n    margin-right: auto;\r\n    margin-left: auto;\r\n}\r\n\r\n.sn_paging i {\r\n    cursor: pointer;\r\n}\r\n\r\n::ng-deep .sn-table {\r\n    font-size: 80%;\r\n}\r\n\r\n.sn-table .bob-cell {\r\n    font-size: 80%;\r\n}\r\n\r\n.usc_dd {\r\n    cursor: pointer;\r\n    vertical-align: -8px;  \r\n    padding-left: 26px;\r\n}\r\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/Azure/Source/Workspaces/SalesNOW/SalesSOLO/WebSites/SalesSOLO.Web.Angular.telesales/src/app/components/usc-store/usc-book-of-business/usc-book-of-business.component.css
// module id = ../../../../../src/app/components/usc-store/usc-book-of-business/usc-book-of-business.component.css
// module chunks = main